export default __webpack_public_path__ + "static/media/appcode.39f95d5f.svg";